import styles from "./styles/uploaded-file-card.module.scss";
import Image from "next/image";
import deleteIcon from "@/assets/icons/delete-icon.svg";

type Props = {
  title: string;
  deleteClick: () => void;
};

const UploadedFileCard = ({ title, deleteClick }: Props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{title}</div>
      <Image
        className={styles.delete}
        width={24}
        src={deleteIcon}
        alt="delete-icon"
        onClick={deleteClick}
      />
    </div>
  );
};

export default UploadedFileCard;
